var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAffordablePrices(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 64,
    height: 64,
    rx: 6,
    fill: "#2F80ED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_8764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3415 50.4874H46.5366C48.2537 50.4874 49.6585 49.0826 49.6585 47.3655V43.8143C50.9854 43.6191 52 42.4874 52 41.1216V36.4387C52 35.0728 50.9854 33.9411 49.6585 33.746V30.1947C49.6585 28.4777 48.2537 27.0728 46.5366 27.0728H43.2976L42.6341 22.663C42.5951 22.4289 42.478 22.2338 42.2829 22.1167C42.0878 21.9996 41.8537 21.9606 41.6585 22.0387L23.9024 27.0728H22.3415C21.0537 27.0728 20 28.1265 20 29.4143V48.146C20 49.4338 21.0537 50.4874 22.3415 50.4874ZM50.439 36.4387V41.1216C50.439 41.785 49.9317 42.2923 49.2683 42.2923H43.4146C42.1268 42.2923 41.0732 41.2387 41.0732 39.9508V37.6094C41.0732 36.3216 42.1268 35.2679 43.4146 35.2679H49.2683C49.9317 35.2679 50.439 35.7752 50.439 36.4387ZM41.2293 23.7557L41.7366 27.0728H29.6L41.2293 23.7557ZM21.561 29.4143C21.561 28.985 21.9122 28.6338 22.3415 28.6338H46.5366C47.3951 28.6338 48.0976 29.3362 48.0976 30.1947V33.7069H43.4146C41.2683 33.7069 39.5122 35.463 39.5122 37.6094V39.9508C39.5122 42.0972 41.2683 43.8533 43.4146 43.8533H48.0976V47.3655C48.0976 48.224 47.3951 48.9265 46.5366 48.9265H22.3415C21.9122 48.9265 21.561 48.5752 21.561 48.146V29.4143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5856 36.4395C43.2978 36.4395 42.2441 37.4931 42.2441 38.7809C42.2441 40.0687 43.2978 41.1224 44.5856 41.1224C45.8734 41.1224 46.9271 40.0687 46.9271 38.7809C46.9271 37.4931 45.8734 36.4395 44.5856 36.4395ZM44.5856 39.5614C44.1563 39.5614 43.8051 39.2102 43.8051 38.7809C43.8051 38.3516 44.1563 38.0004 44.5856 38.0004C45.0149 38.0004 45.3661 38.3516 45.3661 38.7809C45.3661 39.2102 45.0149 39.5614 44.5856 39.5614Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_8764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 28.4878,
    fill: "white",
    transform: "translate(20 22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffordablePrices);
export default __webpack_public_path__ + "static/media/AffordablePrices.e1264e7db163c78d301ec04e45f0ee9a.svg";
export { ForwardRef as ReactComponent };